<template>
<drawer :opened.sync="opened" @close="onCloseBtnClick">
  <template #header>{{operatorTip}}{{editName}}</template>

  <template #body>
    <el-form ref="form" :model="model">
      <el-form-item label="角色名称" prop="name" :rules="[{
        required: true,
        message: '请输入角色名称'
      }]">
        <el-input v-model.trim="model.name" />
      </el-form-item>

      <el-form-item label="角色描述" prop="description">
        <el-input v-model="model.description" type="textarea" style="overflow: auto;" row="2" />
      </el-form-item>

      <el-form-item
        label="模块选择"
        prop="moduleIdList"
        :rules="{
          type: 'array',
          required: true,
          message: '请至少选择一个模块',
          trigger: 'blur'
        }"
      >
        <section class="tree-container border" style="height:480px;">
          <el-tree
            ref="moduleTree"
            :key="treeKey"
            :data="moduleTree"
            :props="{label:'label'}"
            :show-checkbox="true"
            :default-expanded-keys="model.moduleIdList"
            :auto-expand-parent="false"
            :check-on-click-node="true"
            node-key="name"
            @check="onModuleCheckChange"
          />
        </section>
      </el-form-item>
    </el-form>
  </template>

  <template #footer>
    <el-button type="orange" class="btn save-btn" @click="onSaveBtnClick">保存</el-button>
    <el-button v-if="operator === 1" type="orange" plain class="btn save-continue-btn" @click="onSaveContinueBtnClick">保存并继续</el-button>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseEditor from '../../BaseEditor'
import Drawer from '../../../components/Layout/Drawer'

export default {
  name: 'Editor',
  extends: BaseEditor,
  components: {Drawer},
  data () {
    return {
      treeKey: 1
    }
  },
  computed: {
    moduleTree () {
      const moduleTree = JSON.parse(JSON.stringify(this.navList))
      const audit = moduleTree.find(module => module.name === 'DataAudit')

      if (audit) {
        audit.children = audit.children.filter(module => module.name !== 'DataAuditMonthly')
      }

      const tmp = [...moduleTree]
      for (let i = 0; i < tmp.length; i++) {
        const treeNode = tmp[i]
        if (treeNode.name === 'MonthReportLinGang') {
          treeNode.name = 'MonthReport'
          break
        } else {
          const {children} = treeNode
          if (Array.isArray(children) && children.length > 0) {
            tmp.push(...children)
          }
        }
      }

      return moduleTree
    }
  },
  methods: {
    initModel () {
      let tree = this.getModuleTree()
      tree && tree.setCheckedKeys([])

      return {
        id: null,
        name: '',
        description: '',
        moduleIdList: []
      }
    },
    onOpen () {
      this.treeKey++
    },
    onModuleCheckChange () {
      let checkedNodeList = this.getModuleTree().getCheckedNodes()
      this.model.moduleIdList = checkedNodeList.filter(item => !Array.isArray(item.children)).map(item => item.name)
    },
    afterGetDetail (model) {
      let refTree = this.getModuleTree()
      refTree && refTree.setCheckedKeys(model.moduleIdList)
    },
    beforeSave () {
      let {model} = this
      let {moduleIdList} = model

      if (moduleIdList.indexOf('COMMON_MODULE') === -1) {
        moduleIdList.unshift('COMMON_MODULE')
      }
    },
    getModuleTree () {
      return this.$refs.moduleTree
    }
  }
}
</script>

<style scoped>
.el-form-item {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/03Role/Editor.vue